<div
   class="modal-header p-0"
   style="justify-content: end; margin-top: -5px; margin-bottom: 5px">
   <button
      type="button"
      class="btn-close position-static"
      data-bs-dismiss="modal"
      aria-label="Close"
      style="padding-bottom: 4px"
      (click)="onClose()">
      <span aria-hidden="true">×</span>
   </button>
</div>
<div
   class="modal-body p-0"
   style="padding-left: 20px !important; padding-right: 20px !important">
   <div class="d-flex flex-column">
      <h3 class="pb-3">Pricing Update DBX Import</h3>
      <p>You will receive an email on completion</p>
      <div class="p-fluid pb-4">
         <label class="vc-label">Pipeline to Run</label>
         <vc-dropdown-button
            [items]="pipelines"
            idSelector="id"
            textSelector="label"
            [selectedItemId]="selectedPipeline.id"
            (itemSelected)="onSetPipeline($event)"></vc-dropdown-button>
         <br />
         <vc-text-input
            label="Source (Databricks View)"
            placeholder="revenue_analytics.default.pricing_updates"
            type="text"
            required="true"
            [(ngModel)]="sourceInputValue" />

         <vc-spinner *ngIf="isSubmitting.value?.source.length > 0"></vc-spinner>
      </div>
   </div>

   <p-button
      icon="pi pi-save"
      (click)="onSubmit()"
      label="Process"
      severity="primary"
      class="save-button px-2"
      [disabled]="isSubmitting.value?.source.length > 0 || sourceInputValue?.length === 0" />
   <p-button
      icon="pi pi-times"
      (click)="onClose()"
      label="Cancel"
      class="px-2"
      severity="secondary"></p-button>
</div>
